import request from './request';

export default {
	async getStaffs() {
		const res = await request.get('/app/staffs');
		return res;
	}
};
